<template>
        <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
                <div class="row align-items-center">
                    <div class="col-8">
                        <h3 class="mb-0">Neue Organisation hinzufügen</h3>
                    </div>
                </div>
            </div>
            <template>
                <form @submit.prevent="createCustomerAndUser">
                    <base-alert v-if="status.type !== ''" :type="status.type">{{ status.msg }}</base-alert>
                    <h6 class="heading-small text-muted mb-4">Rechnungsanschrift für den Kunden</h6>
                    <div class="pl-lg-4">
                        <div class="row">
                            <div class="col-lg-5">
                                <base-input alternative=""
                                            required
                                            label="Firmenname"
                                            placeholder="Muster GmbH"
                                            input-classes="form-control-alternative"
                                            v-model="customer.name"
                                />
                            </div>
                            <div class="col-lg-6">
                                <base-input alternative=""
                                            required
                                            label="Straße und Hausnummer"
                                            placeholder="Musterstraße 5"
                                            input-classes="form-control-alternative"
                                            v-model="customer.street"
                                />
                            </div>
                            <div v-if="$store.getters['authentication/isAdmin']" class="col-lg-1">
                                <base-input alternative=""
                                            required
                                            label="KNR"
                                            placeholder="K1000"
                                            input-classes="form-control-alternative"
                                            v-model="customer.fakturiaLogin"
                                />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-6">
                                <base-input alternative=""
                                            required
                                            label="Postleitzahl"
                                            placeholder="12345"
                                            input-classes="form-control-alternative"
                                            v-model="customer.postalcode"
                                />
                            </div>
                            <div class="col-lg-6">
                                <base-input alternative=""
                                            required
                                            label="Stadt/Ort"
                                            placeholder="Musterstadt"
                                            input-classes="form-control-alternative"
                                            v-model="customer.city"
                                />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-6">
                                <label class="form-control-label">
                                    Land
                                    <span>*</span></label>
                                <select v-model="customer.country" class="mb-3 custom-select form-control form-control-alternative form-control-lg">
                                    <option value="" disabled selected>Land</option>
                                    <option v-for="country in countries" :key="country.id" :value="country['@id']">{{ country.name }}</option>
                                </select>
                            </div>
                            <div class="col-lg-6">
                                <base-input alternative=""
                                            required
                                            label="USt.-Id:"
                                            placeholder="Umsatzsteuer Identifikationsnr"
                                            input-classes="form-control-alternative"
                                            v-model="customer.vatid"
                                />
                            </div>
                        </div>
                    </div>
                    <hr class="my-4" />
                    <label class="form-control-label">
                        Einen neuen Benutzeraccount für diesen Standort anlegen?</label><br>
                    <switches v-model="createNewUser"
                              theme="bootstrap"
                              color="primary"
                              style="padding-left: 2rem;"
                              text-enabled="Ja, einen neuen Benutzer für diese Organisation anlegen."
                              text-disabled="Nein, es existiert bereits ein Benutzer"></switches><br>
                    <h6 v-if="createNewUser" class="heading-small text-muted mb-4">Ansprechpartner / Betreiberaccountdaten</h6>
                    <div v-if="createNewUser" class="pl-lg-4">
                        <div v-if="createNewUser" class="row">
                                <div class="col-lg-2">
                                    <base-radio class="col-form-label col-form-label-lg mb-3"
                                                input-classes="form-control-alternative form-control-lg"
                                                name="Herr"
                                                v-model="user.title">
                                        Herr
                                    </base-radio>
                                </div>
                                <div class="col-lg-2">
                                    <base-radio class="col-form-label col-form-label-lg mb-3"
                                                input-classes="form-control-alternative form-control-lg"
                                                name="Frau"
                                                v-model="user.title">
                                        Frau
                                    </base-radio>
                                </div>
                        </div>
                        <div v-if="createNewUser" class="row">
                            <div class="col-lg-6">
                                <base-input alternative=""
                                            required
                                            label="Vorname"
                                            placeholder="Max"
                                            input-classes="form-control-alternative"
                                            v-model="user.firstname"
                                />
                            </div>
                            <div class="col-lg-6">
                                <base-input alternative=""
                                            required
                                            label="Nachname"
                                            placeholder="Mustermann"
                                            input-classes="form-control-alternative"
                                            v-model="user.lastname"
                                />
                            </div>
                        </div>
                        <div v-if="createNewUser" class="row">
                            <div class="col-lg-6">
                                <base-input alternative=""
                                            required
                                            label="E-Mail"
                                            placeholder="mustermann@mustermail.de"
                                            input-classes="form-control-alternative"
                                            v-model="user.email"
                                />
                            </div>
                            <div class="col-lg-6">
                                <base-input alternative=""
                                            required
                                            label="Passwort"
                                            placeholder="Passwort"
                                            input-classes="form-control-alternative"
                                            v-model="user.plainPassword"
                                />
                                <base-button type="secondary" size="sm" v-on:click="generatePassword">Passwort generieren</base-button>
                            </div>
                        </div>
                    </div>
                    <button  class="btn btn-icon my-4 btn-primary" :disabled="isLoading">
                        <span class="btn-inner--icon"><i v-if="isLoading" class="fas fa-circle-notch fa-spin"></i><i v-else class="ni ni-fat-add"></i></span>
                        <span class="btn-inner--text">Kunden anlegen</span></button>
                </form>
            </template>
        </card>
</template>

<script>
    import Switches from "vue-switches";
    export default {
        name: "create",
        components:{Switches},
        data() {
            return {
                createNewUser: true,
                customer: {
                    name: "",
                    street: "",
                    postalcode: '',
                    city: "",
                    country: "",
                    vatid: "",
                    fakturiaLogin: ""
                },
                user: {
                    location: null,
                    email: "",
                    plainPassword: "",
                    firstname: "",
                    lastname: "",
                    title: "",
                    roles: ["ROLE_OPERATOR"],
                    comment: ''
                },
                isLoading: false,
                status: {
                    type: '',
                    msg: ''
                }
            }
        },
        created() {
            this.$store.dispatch('country/getCountryCollection');
        },
        computed: {
            countries () {
                return this.$store.getters['country/showCountryCollection'];
            },
        },
        methods: {
            randomStr(len, arr) {
                var ans = '';
                for (var i = len; i > 0; i--) {
                    ans +=
                        arr[Math.floor(Math.random() * arr.length)];
                }
                return ans;
            },
            generatePassword() {
              this.user.plainPassword = this.randomStr(8,'12345678abcdefghijklmnopqrstuvwxyz!$%#?=&');
            },
            createCustomerAndUser() {
                this.isLoading = true;
                this.createCustomer()
                    .then(response => {
                        if (this.createNewUser) {
                            this.createOperatorUser(response)
                                .then(response => {
                                    this.isLoading = false;
                                    //this.status =  {type: 'success', msg: 'Organisation und zugehöriger Betreiberbenutzer (ID: '+response.id+') wurden erstellt. Das Passwort wurde per E-Mail an den Betreiber versendet.'};
                                    this.$store.dispatch('alert/success','Organisation und zugehöriger Betreiberbenutzer (ID: '+response.id+') wurden erstellt. Das Passwort wurde per E-Mail an den Betreiber versendet.')
                                })
                                .catch(error => {
                                    this.isLoading = false;
                                    //this.status =  {type: 'danger', msg: error};
                                    this.$store.dispatch('alert/error',error);
                                })
                        } else {
                            this.isLoading = false;
                            //this.status =  {type: 'success', msg: 'Organisation (ID: '+response.id+') wurden erstellt.'};
                            this.$store.dispatch('alert/success','Organisation (ID: '+response.id+') wurden erstellt.');
                        }

                        this.$store.dispatch('customer/getCustomerCollection');
                    })
                    .catch(error => {
                    this.isLoading = false;
                    this.status =  {type: 'danger', msg: error};
                })

            },
            createCustomer() {
                return new Promise((resolve, reject) => {
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    let senddata = this.customer;
                    const requestOptions = {
                        method: 'POST',
                        headers: header,
                        body: JSON.stringify(senddata)
                    };
                    fetch(process.env.VUE_APP_API_SERVER + `/api/customers`, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                                resolve(response);
                            },
                            error => {
                                reject(error);
                            });
                });
            },
            createOperatorUser(customer) {
                return new Promise((resolve, reject) => {
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    let senddata = this.user;
                    senddata['customer'] = customer['@id'];
                    const requestOptions = {
                        method: 'POST',
                        headers: header,
                        body: JSON.stringify(senddata)
                    };
                    fetch(process.env.VUE_APP_API_SERVER + `/api/users`, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                                resolve(response);
                            },
                            error => {
                                reject(error);
                            });
                });
            }
        }
    }
</script>

<style scoped>

</style>